import Button from "../controls/Button";

import { buildAuditUrl } from "./auditEntityConfig";

export default function AuditActionLink({
  slug,
  id,
  name,
  className = "",
}) {
  return (
    <Button
      variant="info"
      to={buildAuditUrl(slug, id, name)}
      target="_blank"
      rel="noopener noreferrer"
      className={className ? `ml-2 ${className}` : "ml-2"}
    >
      Audit
    </Button>
  );
}
